import { Injectable, inject, signal } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, skip } from 'rxjs/operators';
import { HeaderLoadingService } from './header-loading.service';

@Injectable({ providedIn: 'root' })
export class HttpCancelService {
  private cancelTrigger = signal(0);
  public onCancel$ = toObservable(this.cancelTrigger).pipe(skip(1));

  constructor() {
    const router = inject(Router);
    const loadingService = inject(HeaderLoadingService);

    router.events
      .pipe(filter((event) => event instanceof NavigationStart))
      .subscribe(() => {
        this.cancelTrigger.update((val) => val + 1);
        loadingService.reset();
      });
  }
}
